<div class="content-inner loading" *ngIf="loading"></div>

<ng-template [ngIf]="!loading">      
<div class="content-inner">
    <div class="form-body" [formGroup]="acuityForm">
        <div class="workflow-section-heading">Activity Categories</div>
        <section class="workflow-input-group">
            <div class="workflow-input" *ngFor="let acuityCategory of acuityCategories">
                <input type="number" min="0" attr.aria-label="'acuity ' + acuityCategory.id" [formControlName]="getAcuityControlName(acuityCategory.id)">
                <span class="display-label">{{ acuityCategory.name }}</span>
                <div *ngIf="valueOutOfRange(acuityCategory.id)" class="validation-message warning">
                    Value must be greater than zero.
                </div>
            </div> 
            <div class="workflow-input totals">
                <input type="text" disabled attr.aria-label="Total" [value]="acuityCensusTotal">
                <span class="display-label">Total</span>
            </div>
        </section>  
        <section [formGroup]="staffForm">
            <div class="workflow-section-heading">Enter Staffing Levels</div>
            <div class="loading" *ngIf="loadingRecommendations"></div>
            <ng-container *ngIf="jobTitlesWithVariance.length > 0">
              <div class="warning notification" *ngFor="let varianceWarning of getVarianceWarnings()">
                <span class="icon-notification"></span> {{ varianceWarning }}
              </div>
            </ng-container>
            <section *ngIf="shiftRecord.costCenter.variableJobTitles.length" class="workflow-input-group">
                <div class="workflow-section-subheading">Variable Staff</div>
                <div class="workflow-input-labels">
                    <span>Target</span>
                    <span>Actual</span>
                </div>
                <div class="workflow-input" *ngFor="let varStaff of shiftRecord.costCenter.variableJobTitles">
                    <input type="text" disabled [attr.aria-label]="'Target ' + varStaff.abbreviation" [value]="getRecommendedStaffText(varStaff.id)">
                    <input type="number" min="0" [attr.aria-label]="'Actual ' + varStaff.abbreviation" [formControlName]="getStaffControlName(varStaff.id)">
                    <span class="display-label">{{ varStaff.abbreviation }}</span>
                    <div *ngIf="controlValueOutOfRange(varStaff.id)" class="validation-message warning">
                        Value must be between {{minValue}} and {{maxValue | number}}.
                    </div>
                </div>
            </section>    
            <section *ngIf="shiftRecord.costCenter.fixedJobTitles.length" class="workflow-input-group">
                <a class="workflow-section-link" (click)="toggleFixedStaff()">Fixed Staff</a>  
                &nbsp;
                <button class="compact" (click)="toggleFixedJobEditing(true)"><span class="icon-pencil"></span> Edit</button>
                <ng-template [ngIf]="showFixedStaff">  
                    <div class="workflow-input-labels">
                        <span>Target</span>
                        <span>Actual</span>
                    </div>
                    <div class="workflow-input" *ngFor="let fixed of shiftRecord.costCenter.fixedJobTitles">
                        <input type="text" disabled [attr.aria-label]="'Target ' + fixed.abbreviation" [value]="getRecommendedStaffText(fixed.id)">
                        <input type="number" min="0" [attr.aria-label]="'Actual ' + fixed.abbreviation" [formControlName]="getStaffControlName(fixed.id)">
                        <span class="display-label">{{ fixed.abbreviation }}</span>
                        <div *ngIf="controlValueOutOfRange(fixed.id)" class="validation-message warning">
                            Value must be between {{minValue}} and {{maxValue | number}}.
                        </div>
                    </div>
                </ng-template>
            </section>
        </section>        
    </div>
</div>
</ng-template>